import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export function PresetsGallery({ open, onOpenChange, presets, onLoadPreset }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl rounded-sm" data-testid="presets-dialog">
        <DialogHeader>
          <DialogTitle className="text-sm font-bold uppercase tracking-wider">Plantillas predefinidas</DialogTitle>
          <DialogDescription className="text-xs text-slate-500">Selecciona una base profesional para empezar. Podras personalizarla despues.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 py-2">
          {presets.map(p => (
            <button key={p.id} onClick={() => onLoadPreset(p)} className="text-left border border-slate-200 rounded-sm p-3 hover:border-slate-400 hover:shadow-sm transition-all group" data-testid={`preset-${p.id}`}>
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-5 rounded-sm flex overflow-hidden">
                  <div className="flex-1" style={{ backgroundColor: p.preview.bg }} />
                  <div className="w-1" style={{ backgroundColor: p.preview.accent }} />
                </div>
                <span className="text-xs font-bold text-slate-800">{p.name}</span>
              </div>
              <p className="text-[10px] text-slate-500">{p.desc}</p>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function ResetConfirmDialog({ open, onOpenChange, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-sm" data-testid="reset-confirm-dialog">
        <DialogHeader>
          <DialogTitle className="text-sm font-bold">Restablecer layout</DialogTitle>
          <DialogDescription className="text-xs text-slate-500">Esto eliminara todos los cambios y volvera al layout por defecto. Esta accion se puede deshacer con Ctrl+Z.</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 pt-2">
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)} className="rounded-sm">Cancelar</Button>
          <Button size="sm" onClick={onConfirm} className="bg-red-600 hover:bg-red-700 rounded-sm" data-testid="confirm-reset-btn">Restablecer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
